import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IAuthState, authTypes } from './types';
import * as authActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IAuthState = {
  isAuthenticated: null,
  user: null,
  permissions: [],
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IAuthState, action: UnsafeReturnType<T>): IAuthState;
}

const setAuth: IActionHandler<typeof authActions['setAuth']> = (state, { payload }) => ({
  ...state,
  isAuthenticated: payload.isAuthenticated,
  user: payload.user,
});

const setPermissions: IActionHandler<typeof authActions['setPermissions']> = (state, { payload }) => ({
  ...state,
  permissions: payload.permissions,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [authTypes.SET_AUTH]: setAuth,
  [authTypes.SET_PERMISSIONS]: setPermissions,
};

const authReducer = createReducer<IAuthState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { authReducer, authTypes, authActions };
